import React, { useEffect } from "react";
import clsx from "clsx";
import { ItemProps } from "../SimpleCarousel/types";
import { twMerge } from "tailwind-merge";

export const SimpleCarouselItem: React.FC<ItemProps> = (props: ItemProps) => {
  const { refer } = props;
  const thisRef = React.useRef<any>();

  useEffect(() => {
    refer?.(thisRef);
  }, [thisRef, refer]);

  return (
    <div
      ref={thisRef}
      id={props.id}
      className={twMerge(
        clsx(`carousel-item w-full `, props?.itemCustomClass ?? "")
      )}
    >
      {props.children}
    </div>
  );
};

export default SimpleCarouselItem;
